import ScrollBar from "react-perfect-scrollbar";
import { Card, CardBody, Col, Row } from "reactstrap";
import { bothSideScroll, bothSideScrollSubTitle } from "../../../../Data/BonusUi/Scrollable";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { BothSideScrollbarTitle } from "../../../../Utils/Constants";

export default function BothSideScrollbar() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={BothSideScrollbarTitle} subTitle={bothSideScrollSubTitle} />
        <CardBody>
          <div className="scroll-bar-wrap">
            <ScrollBar className="scroll-demo" style={{ width: "100%", height: "300px" }}>
              <div className="horz-scroll-content scroll-content-width">
                <Row>
                  {bothSideScroll &&
                    bothSideScroll.map((item, index) => (
                      <Col sm={3} key={index}>
                        {item.text}
                      </Col>
                    ))}
                </Row>
              </div>
            </ScrollBar>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
